export enum StatusChassi {
	
	valid = 0 ,
	invalid = 1 ,
	notProcessed = 2
}

